<template>
    <div class="absolute bg-white bg-opacity-75 z-[9999] w-full h-full">
        <div class="max-h-[50%] h-full w-full flex items-center justify-center">
            <Loader />
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Utils/Loader.vue";
export default {
    name: 'LoadingSpinner',
    components: {
        Loader
    },
}
</script>